import _isEqual from 'lodash/isEqual';

export class Key {
	constructor() {
		if (arguments.length === 3) {
			let [parent, kind, id] = arguments;
			if (parent) {
				this.data = Array.from(parent.data);
			} else {
				this.data = [];
			}
			this.data.push(kind, id);
		} else {
			this.data = arguments[0];
		}
	}

	get kind() {
		return this.data[this.data.length - 2];
	}

	get id() {
		return this.data[this.data.length - 1];
	}

	get parent() {
		let parent = null;
		if (this.data.length > 2) {
			parent = new Key(this.data.slice(0, -2));
		}
		return parent;
	}

	// generator generated by babel is buggy on ff
	// *segments() {
	// 	for (let i = 0, len = this.data.length; i < len; i += 2) {
	// 		yield {kind: this.data[i], id: this.data[i + 1]};
	// 	}
	segments() {
		const segments = [];
		for (let i = 0, len = this.data.length; i < len; i += 2) {
			segments.push({kind: this.data[i], id: this.data[i + 1]});
		}
		return segments;
	}

	get root() {
		let root = null;
		if (this.data.length > 2) {
			root = new Key(this.data.slice(0, 2));
		}
		return root;
	}

	toString() {
		return this.data.join('-');
	}

	equals(key) {
		if (!(key && key.data))
			return false;
		return _isEqual(this.data, key.data);
	}

	static fromString(s) {
		var key = null;
		if (s) {
			key = new Key(s.split('-'));
		}
		return key;
	}
}



// WEBPACK FOOTER //
// ./src/core/key.js